module.exports = __webpack_public_path__ + "img/capt_d.3a23bf7b.jpg";